var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90 54H30C23.3825 54 18 48.6175 18 42V39C18 32.3825 23.3825 27 30 27H90C96.6175 27 102 32.3825 102 39V42C102 48.6175 96.6175 54 90 54ZM30 33C26.6925 33 24 35.6925 24 39V42C24 45.3075 26.6925 48 30 48H90C93.3075 48 96 45.3075 96 42V39C96 35.6925 93.3075 33 90 33H30Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78 102H42C35.3825 102 30 96.6175 30 90V51H36V90C36 93.3075 38.6925 96 42 96H78C81.3075 96 84 93.3075 84 90V51H90V90C90 96.6175 84.6175 102 78 102Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63 57H57V90.2025H63V57Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51 57H45V90.2025H51V57Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M75 57H69V90.2025H75V57Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M75 30H69C69 25.0375 64.9625 21 60 21C55.0375 21 51 25.0375 51 30H45C45 21.73 51.73 15 60 15C68.27 15 75 21.73 75 30Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.9ed50bde.svg";
export { ForwardRef as ReactComponent };